import VueCookie from 'vue-cookie'
import Router from '../router/index.js'
import Axios from 'axios'

const Fs = {
    state: {
        buckets: null,
        bucket: null,
        bucketPath: '',
        files: null
    },
    getters: {
        get_buckets: (state) => {
            return state.buckets
        },
        get_bucket: (state) => {
            return state.bucket
        },
        get_bucketPath: (state) => {
            return state.bucketPath
        },
        get_files: (state) => {
            return state.files
        }
    },
    mutations: {
        set_buckets: (state, payload) => {
            state.buckets = payload
        },
        set_bucket: (state, payload) => {
            state.bucket = payload
        },
        set_bucketPath: (state, payload) => {
            state.bucketPath = payload
        },
        set_files: (state, payload) => {
            state.files = payload
        }
    },
    actions: {
        api_index_buckets: (context) => {
            Axios.get(process.env.VUE_APP_JOAT_URL + '/fs/buckets', {
                headers: {
                    Authorization: context.rootGetters['Projects/get_firstKey']
                }
          })
        .then(response => {
            context.commit('set_buckets', response.data)
        })
        },
        api_index_files: (context) => {
            let bucketHash = context.getters.get_bucket.hash;
            let bucketPath = context.getters.get_bucketPath;
            Axios.get(process.env.VUE_APP_JOAT_URL + '/fs/buckets/' + bucketHash + '/files?path=' + bucketPath, {
                headers: {
                    Authorization: context.rootGetters['Projects/get_firstKey']
                }
            })
                .then(response => {
                    context.commit('set_files', response.data)
                })
        }
    },
    namespaced: true
}
export default Fs
